import React from "react";
import { Button, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const TonalButtonWithEndIcon = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Tonal button with end icon"}
        value={
          '<Button variant={"tonal"} endIcon={<ArrowRightIcon />} color={"success"}>Next</Button>'
        }
      >
        <Button
          variant={"tonal"}
          endIcon={<ArrowRightIcon />}
          color={"success"}
        >
          Next
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default TonalButtonWithEndIcon;
